import { Profile } from 'store/slices/profileSlice';

export const getProfileHasPin = (profile: Profile): boolean => {
  if (profile.isKid) return false;
  return true;
};
